<template>
    <section>

        <div class="page">
            <div>
                <h2>Deleting messages</h2>
                <p>You can delete messages for everyone or just for yourself.
                </p>
                <h3>To delete messages for everyone</h3>
                <p>Deleting messages for everyone allows you to delete specific messages you've sent to either a group
                    or an
                    individual chat. This is particularly useful if you sent a message to the wrong chat or if the
                    message you
                    sent contains a mistake.
                </p>
                <p>
                    Messages you successfully delete for everyone will be replaced with "Someone deleted the message" in
                    your
                    recipients' chats (*). Similarly, if you see "Someone deleted the message" in a chat, it means that
                    the
                    sender deleted their message for everyone.
                </p>
                <p>To delete messages for everyone:</p>
                <ol>
                    <li>Open ToTok and go to the chat containing the message you wish to delete.</li>
                    <li>Long press the message. Click Delete on the prompted menu. Optionally, select more
                        messages to delete
                        multiple messages at once.
                    </li>
                    <li>Tap trash box button at the bottom of the screen > Delete for Everyone.</li>
                </ol>
                <h3>To delete messages for yourself</h3>
                <p>Deleting messages for yourself allows you to delete your copy of messages you've sent or received from your phone. This has no effect on your recipients' chats. Your recipients will still see the messages in their chat screen. To delete messages for yourself:               
                </p>
                <ol>
                    <li>Open ToTok and go to the chat containing the message you wish to delete.</li>
                    <li>Long press the message. Click Delete on the prompted menu. Optionally, select more
                        messages to delete
                        multiple messages at once.
                    </li>
                    <li>Tap trash box button at the bottom of the screen > Delete for Me.</li>
                </ol>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
